import React from 'react';
import { connect } from 'react-redux';

import "./styles.scss";

import Input from '../../../../components/Input';
import { unitLabel, unitTransform } from '../../../../services/helper.service';
import { defaultUnits } from '@config';

import { setServiceTemperature } from '@reducers/selectors/material/actions';

import { APP_TEXTS } from '@texts';

// eslint-disable-next-line react/prefer-stateless-function
class ServiceTemperature extends React.Component {

  render() {
    return (
      <div className="list-type">
        <Input
          className="service-temperature"
          prefix={APP_TEXTS.MATERIAL_SERVICE_TEMPERATURE_TITLE.Content}//"Service temperature"
          postfix={unitLabel(this.props.temperatureUnit)}
          id="service_temperature"
          type="number"
          value={unitTransform(this.props.value).from(defaultUnits.TEMPERATURE).to(this.props.temperatureUnit)}
          onUpdate={value => {
            this.props.setServiceTemperature(unitTransform(+value, false).from(this.props.temperatureUnit).to(defaultUnits.TEMPERATURE));
          }}
        />
      </div>
    );
  }

}

const mapState = state => ({
  temperatureUnit: state.main.units.temperature,

  value: state.selectors.material[state.main.appType].serviceTemperature.value
});

const mapDispatch = dispatch => ({
  setServiceTemperature: value => dispatch(setServiceTemperature(value))
});

export default connect(mapState, mapDispatch)(ServiceTemperature);



// WEBPACK FOOTER //
// ./src/views/Material/components/ServiceTemperature/index.js